import { useCallback, useRef } from 'react';
import { THandleReset } from './types';
import { IHandleInputParams, TInputState } from '../types';
import { reduce } from 'lodash';

export const useHandleReset = ({
  inputs,
  setInputs,
}: IHandleInputParams): THandleReset => {
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;

  return useCallback(() => {
    const current = inputsRef.current;
    setInputs(
      reduce(
        current,
        (r, v, k) => ({
          ...r,
          [k]: {
            ...v,
            reset: true,
          },
        }),
        {} as Record<string, TInputState>
      )
    );
  }, [setInputs]);
};
